import { render, staticRenderFns } from "./ProcurationDetailsForm.vue?vue&type=template&id=268b432a&"
import script from "./ProcurationDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ProcurationDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports